import React from "react";
import * as S from "./ReceiptStyle";

export default function Receipt({ receipt, onClose }) {
  if (!receipt) return null;

  const isPdf =
    receipt.receiptUrl.toLowerCase().includes(".pdf") ||
    receipt.receiptUrl.toLowerCase().includes("alt=media");
  // Firebase urls usually download, but let's try to display if possible.

  return (
    <S.Overlay onClick={onClose}>
      <S.Modal onClick={(e) => e.stopPropagation()}>
        <S.Header>
          <h2>Detalhes do Recibo #{receipt.id}</h2>
          <S.CloseButton onClick={onClose}>&times;</S.CloseButton>
        </S.Header>
        <S.Content>
          <S.InfoSide>
            <S.InfoItem>
              <label>Cliente</label>
              <p>{receipt.clientName}</p>
            </S.InfoItem>
            <S.InfoItem>
              <label>Tipo</label>
              <p>{receipt.type === "RECIBO_DE_SAQUE" ? "Saque" : "Contrato"}</p>
            </S.InfoItem>
            <S.InfoItem>
              <label>Data</label>
              <p>{new Date(receipt.dateCreated).toLocaleString()}</p>
            </S.InfoItem>
            <S.InfoItem>
              <label>Referência</label>
              <p>
                {receipt.type === "RECIBO_DE_SAQUE"
                  ? `Saque ID: ${receipt.itemId}`
                  : `Contrato ID: ${receipt.contractId}`}
              </p>
            </S.InfoItem>
            {receipt.contractId > 0 && (
              <S.InfoItem>
                <label>Contrato Vinculado</label>
                <p>#{receipt.contractId}</p>
              </S.InfoItem>
            )}
            <S.InfoItem>
              <label>Descrição</label>
              <p>{receipt.description}</p>
            </S.InfoItem>
          </S.InfoSide>

          <S.PreviewSide>
            <object
              data={receipt.receiptUrl}
              type="application/pdf"
              width="100%"
              height="100%"
            >
              <img
                src={receipt.receiptUrl}
                alt="Recibo"
                onError={(e) => (e.target.style.display = "none")}
              />
              <p style={{ color: "white", padding: 20 }}>
                Não foi possível pré-visualizar. Clique em baixar.
              </p>
            </object>
          </S.PreviewSide>
        </S.Content>
        <S.Footer>
          <S.LinkButton
            href={receipt.receiptUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Abrir Original / Baixar
          </S.LinkButton>
        </S.Footer>
      </S.Modal>
    </S.Overlay>
  );
}
